import React, { useLayoutEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { getAvailableActions } from './utils/permissionCatalog';

type SidebarSection = {
  key: string;
  label: string;
  isHidden?: boolean;
  requiredActions?: string[];
};

type SidebarProps = {
  sections: SidebarSection[];
  toByKey: Record<string, string>;
  currentUser?: any;
};

function PackagesIcon() {
  return (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.2448 5.18658C20.2448 5.103 20.2263 5.01942 20.1891 4.94048C20.1148 4.78261 19.9709 4.67581 19.813 4.64331L10.3546 0.0557197C10.2014 -0.0185732 10.0203 -0.0185732 9.86703 0.0557197L0.315745 4.6851C0.130013 4.77332 0.00928662 4.95905 0 5.168V5.17265C0 5.17729 0 5.18193 0 5.19122V16.8088C0 17.0224 0.120726 17.2174 0.315745 17.3103L9.86703 21.9396C9.87168 21.9396 9.87168 21.9396 9.87632 21.9443C9.89025 21.9489 9.90418 21.9536 9.91811 21.9629C9.92275 21.9629 9.9274 21.9675 9.93668 21.9675C9.95061 21.9721 9.96454 21.9768 9.97847 21.9814C9.98312 21.9814 9.98776 21.9861 9.9924 21.9861C10.0063 21.9907 10.0249 21.9907 10.0388 21.9954C10.0435 21.9954 10.0481 21.9954 10.0528 21.9954C10.0713 21.9954 10.0946 22 10.1131 22C10.1317 22 10.1549 22 10.1735 21.9954C10.1781 21.9954 10.1828 21.9954 10.1874 21.9954C10.2014 21.9954 10.2199 21.9907 10.2339 21.9861C10.2385 21.9861 10.2431 21.9814 10.2478 21.9814C10.2617 21.9768 10.2756 21.9721 10.2896 21.9675C10.2942 21.9675 10.2989 21.9629 10.3081 21.9629C10.3221 21.9582 10.336 21.9536 10.3499 21.9443C10.3546 21.9443 10.3546 21.9443 10.3592 21.9396L19.9384 17.2963C20.1287 17.2035 20.2541 17.0084 20.2541 16.7949V5.20051C20.2448 5.19586 20.2448 5.19122 20.2448 5.18658ZM10.1085 1.17476L18.3921 5.19122L15.3415 6.67244L7.05783 2.65597L10.1085 1.17476ZM10.1085 9.20768L1.82482 5.19122L5.78092 3.27353L14.0646 7.29L10.1085 9.20768ZM1.11439 6.08738L9.55129 10.1781V20.5466L1.11439 16.4559V6.08738ZM10.6657 20.5466V10.1781L14.6264 8.2558V10.9675C14.6264 11.274 14.8772 11.5247 15.1836 11.5247C15.4901 11.5247 15.7408 11.274 15.7408 10.9675V7.71254L19.1304 6.06881V16.4373L10.6657 20.5466Z" fill="currentColor"/>
    </svg>
  );
}

function TemplatesIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.65 8.6499H16.65M10.65 12.6499H16.65M10.65 16.6499H16.65M0.650024 1.6499C0.650024 1.38469 0.755381 1.13033 0.942918 0.942796C1.13045 0.755259 1.38481 0.649902 1.65002 0.649902H15.65C15.9152 0.649902 16.1696 0.755259 16.3571 0.942796C16.5447 1.13033 16.65 1.38469 16.65 1.6499V3.6499C16.65 3.91512 16.5447 4.16947 16.3571 4.35701C16.1696 4.54455 15.9152 4.6499 15.65 4.6499H1.65002C1.38481 4.6499 1.13045 4.54455 0.942918 4.35701C0.755381 4.16947 0.650024 3.91512 0.650024 3.6499V1.6499ZM0.650024 9.6499C0.650024 9.38469 0.755381 9.13033 0.942918 8.9428C1.13045 8.75526 1.38481 8.6499 1.65002 8.6499H5.65002C5.91524 8.6499 6.16959 8.75526 6.35713 8.9428C6.54467 9.13033 6.65002 9.38469 6.65002 9.6499V15.6499C6.65002 15.9151 6.54467 16.1695 6.35713 16.357C6.16959 16.5445 5.91524 16.6499 5.65002 16.6499H1.65002C1.38481 16.6499 1.13045 16.5445 0.942918 16.357C0.755381 16.1695 0.650024 15.9151 0.650024 15.6499V9.6499Z" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function LabelPrintsIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.00002 15H3.33335C2.89133 15 2.4674 14.8244 2.15484 14.5118C1.84228 14.1993 1.66669 13.7754 1.66669 13.3333V9.16667C1.66669 8.72464 1.84228 8.30072 2.15484 7.98816C2.4674 7.6756 2.89133 7.5 3.33335 7.5H16.6667C17.1087 7.5 17.5326 7.6756 17.8452 7.98816C18.1578 8.30072 18.3334 8.72464 18.3334 9.16667V13.3333C18.3334 13.7754 18.1578 14.1993 17.8452 14.5118C17.5326 14.8244 17.1087 15 16.6667 15H15" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 7.49984V2.49984C5 2.27882 5.0878 2.06686 5.24408 1.91058C5.40036 1.7543 5.61232 1.6665 5.83333 1.6665H14.1667C14.3877 1.6665 14.5996 1.7543 14.7559 1.91058C14.9122 2.06686 15 2.27882 15 2.49984V7.49984" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M14.1667 11.6665H5.83333C5.3731 11.6665 5 12.0396 5 12.4998V17.4998C5 17.9601 5.3731 18.3332 5.83333 18.3332H14.1667C14.6269 18.3332 15 17.9601 15 17.4998V12.4998C15 12.0396 14.6269 11.6665 14.1667 11.6665Z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

function ProductsIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_2215_6759"  maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <path d="M15.3496 15.3496V0.650389H0.650391V15.3496H15.3496Z" fill="white" stroke="white" strokeWidth="1.3"/>
      </mask>
      <g mask="url(#mask0_2215_6759)">
        <path d="M13.8837 0.940945H8.19222L1.28383 7.84927C0.82694 8.30631 0.82694 9.05412 1.28383 9.51101L6.4887 14.7159C6.94568 15.1728 7.69336 15.1728 8.15039 14.7158L15.0586 7.80741L15.0588 2.11592C15.0588 1.46966 14.53 0.940945 13.8837 0.940945Z" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.2909 5.03976C11.9234 5.40732 11.3275 5.40732 10.9599 5.03976C10.5924 4.6722 10.5924 4.07626 10.9599 3.70879C11.3275 3.34117 11.9234 3.34111 12.2909 3.70879C12.6585 4.07626 12.6585 4.6722 12.2909 5.03976Z" stroke="currentColor" strokeWidth="0.75" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  );
}

function _UserManagementIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M15.8333 17.5V15.8333C15.8333 14.9493 15.4821 14.1014 14.857 13.4763C14.2319 12.8512 13.384 12.5 12.5 12.5H7.49996C6.6159 12.5 5.76806 12.8512 5.14294 13.4763C4.51782 14.1014 4.16663 14.9493 4.16663 15.8333V17.5"
        stroke="currentColor"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
        stroke="currentColor"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function _MetrcImportsIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M12.4585 10.2296C12.2825 10.2296 12.1065 10.1626 11.9725 10.0282C10.9003 8.95601 9.15577 8.95567 8.08327 10.0282C7.81514 10.2966 7.37927 10.2966 7.11114 10.0282C6.84267 9.7597 6.84267 9.32451 7.11114 9.05604C8.71955 7.44729 11.3365 7.44764 12.9446 9.05604C13.213 9.32451 13.213 9.7597 12.9446 10.0282C12.8105 10.1626 12.6342 10.2296 12.4585 10.2296Z"
        fill="currentColor"
      />
      <path
        d="M11.9724 14.1512C10.9161 14.1512 9.85975 13.749 9.05572 12.945C8.78725 12.6765 8.78725 12.2413 9.05572 11.9728C9.32385 11.7044 9.75972 11.7044 10.0278 11.9728C11.1 13.045 12.8445 13.0453 13.917 11.9728C14.1852 11.7044 14.621 11.7044 14.8892 11.9728C15.1576 12.2413 15.1576 12.6765 14.8892 12.945C14.0848 13.749 13.0284 14.1512 11.9724 14.1512Z"
        fill="currentColor"
      />
      <path
        d="M14.4027 13.146C14.2267 13.146 14.0507 13.0789 13.9167 12.9445C13.6482 12.676 13.6482 12.2409 13.9167 11.9724L17.7571 8.13202C18.0252 7.86355 18.4611 7.86355 18.7292 8.13202C18.9977 8.40048 18.9977 8.83567 18.7292 9.10414L14.8888 12.9445C14.7547 13.0789 14.5787 13.146 14.4027 13.146Z"
        fill="currentColor"
      />
      <path
        d="M8.6182 18.9308C8.4422 18.9308 8.2662 18.8638 8.13214 18.7294C7.86367 18.4609 7.86367 18.0257 8.13214 17.7573L10.2789 15.6105C10.547 15.3421 10.9829 15.3421 11.251 15.6105C11.5194 15.879 11.5194 16.3142 11.251 16.5827L9.10426 18.7294C8.9702 18.8638 8.7942 18.9308 8.6182 18.9308Z"
        fill="currentColor"
      />
      <path
        d="M3.75687 14.0694C3.58087 14.0694 3.40487 14.0024 3.27081 13.868C3.00234 13.5995 3.00234 13.1643 3.27081 12.8959L7.11118 9.05584C7.37965 8.78737 7.81518 8.78737 8.08331 9.05584C8.35178 9.32431 8.35178 9.7595 8.08331 10.028L4.24293 13.868C4.10853 14.0021 3.93253 14.0694 3.75687 14.0694Z"
        fill="currentColor"
      />
      <path
        d="M11.2351 6.59131C11.0591 6.59131 10.8835 6.52428 10.7491 6.39022C10.4806 6.12175 10.4806 5.68656 10.7491 5.41775L12.8958 3.27069C13.1643 3.00222 13.5995 3.00222 13.8683 3.27069C14.1367 3.53916 14.1367 3.97434 13.8683 4.24316L11.7215 6.39022C11.5871 6.52394 11.4108 6.59131 11.2351 6.59131Z"
        fill="currentColor"
      />
      <path
        d="M6.18749 19.9154C5.12428 19.9154 4.06106 19.5201 3.27078 18.7295C1.68953 17.1482 1.68953 14.4769 3.27078 12.8957C3.5389 12.6272 3.97478 12.6272 4.2429 12.8957C4.51137 13.1642 4.51137 13.5993 4.2429 13.8678C3.18896 14.9217 3.18896 16.7031 4.2429 17.757C5.29684 18.8109 7.07815 18.8109 8.13209 17.757C8.40021 17.4885 8.83609 17.4885 9.10421 17.757C9.37268 18.0255 9.37268 18.4607 9.10421 18.7291C8.31393 19.5201 7.25071 19.9154 6.18749 19.9154Z"
        fill="currentColor"
      />
      <path
        d="M18.2432 9.30577C18.0672 9.30577 17.8912 9.23874 17.7571 9.10434C17.4887 8.83587 17.4887 8.40068 17.7571 8.13221C18.8111 7.07827 18.8111 5.29696 17.7571 4.24302C16.7032 3.18909 14.9219 3.18909 13.8679 4.24302C13.5998 4.51149 13.1639 4.51149 12.8958 4.24302C12.6273 3.97455 12.6273 3.53937 12.8958 3.2709C14.4771 1.68965 17.1483 1.68965 18.7296 3.2709C20.3108 4.85215 20.3108 7.52343 18.7296 9.10468C18.5952 9.23874 18.4192 9.30577 18.2432 9.30577Z"
        fill="currentColor"
      />
    </svg>
  );
}

function _BrandsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g clipPath="url(#clip0_549_31356)">
        <path
          d="M16.875 19.375H3.125C2.79358 19.3747 2.47583 19.2429 2.24148 19.0085C2.00713 18.7742 1.87533 18.4564 1.875 18.125V1.875C1.87533 1.54359 2.00713 1.22584 2.24148 0.991486C2.47583 0.757138 2.79358 0.625335 3.125 0.625005H12.8662C13.0304 0.624561 13.1931 0.656701 13.3448 0.719563C13.4965 0.782424 13.6342 0.874758 13.75 0.991217L17.7588 5C17.8752 5.11578 17.9676 5.2535 18.0304 5.40521C18.0933 5.55691 18.1254 5.71958 18.125 5.88379V18.125C18.1247 18.4564 17.9929 18.7742 17.7585 19.0085C17.5242 19.2429 17.2064 19.3747 16.875 19.375ZM3.125 1.875V18.125H16.8759L16.875 5.88379L12.8662 1.875H3.125Z"
          fill="currentColor"
        />
        <path
          d="M17.5 6.87494H13.75C13.4186 6.87461 13.1008 6.7428 12.8665 6.50846C12.6321 6.27411 12.5003 5.95636 12.5 5.62494V1.3125C12.5 1.14674 12.5658 0.987768 12.6831 0.870558C12.8003 0.753348 12.9592 0.6875 13.125 0.6875C13.2908 0.6875 13.4497 0.753348 13.5669 0.870558C13.6842 0.987768 13.75 1.14674 13.75 1.3125V5.62494H17.5C17.6658 5.62494 17.8247 5.69079 17.9419 5.808C18.0592 5.92521 18.125 6.08418 18.125 6.24994C18.125 6.4157 18.0592 6.57467 17.9419 6.69188C17.8247 6.80909 17.6658 6.87494 17.5 6.87494Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_549_31356">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function _OrganizationsIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <g clipPath="url(#clip0_536_42823)">
        <mask id="mask0_536_42823" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
          <path d="M0 1.90735e-06H20V20H0V1.90735e-06Z" fill="white" />
        </mask>
        <g mask="url(#mask0_536_42823)">
          <path
            d="M11.8828 2.70629C12.5735 2.88453 13.2259 3.15817 13.825 3.51246C13.825 3.51246 14.1136 3.22375 14.4378 2.89957C14.6732 2.66395 14.9926 2.5318 15.3255 2.5318C15.6581 2.5318 15.9776 2.66395 16.213 2.89957C16.4985 3.18516 16.8148 3.50145 17.1004 3.78703C17.3361 4.02238 17.4682 4.34184 17.4682 4.67446C17.4682 5.00742 17.3361 5.32684 17.1004 5.56219C16.7762 5.88637 16.4875 6.17504 16.4875 6.17504C16.8418 6.7741 17.1154 7.42649 17.2937 8.11719H18.1588C18.852 8.11719 19.4141 8.67922 19.4141 9.37238V10.6276C19.4141 11.3208 18.852 11.8828 18.1588 11.8828H17.2937C17.1154 12.5735 16.8418 13.2259 16.4875 13.8249C16.4875 13.8249 16.7762 14.1136 17.1004 14.4378C17.3361 14.6732 17.4682 14.9926 17.4682 15.3255C17.4682 15.6582 17.3361 15.9776 17.1004 16.213C16.8148 16.4985 16.4985 16.8148 16.213 17.1004C15.9776 17.3361 15.6581 17.4682 15.3255 17.4682C14.9926 17.4682 14.6732 17.3361 14.4378 17.1004C14.1136 16.7762 13.825 16.4875 13.825 16.4875C13.2259 16.8418 12.5735 17.1155 11.8828 17.2937V18.1588C11.8828 18.852 11.3208 19.4141 10.6276 19.4141H9.37238C8.67918 19.4141 8.11719 18.852 8.11719 18.1588V17.2937C7.42652 17.1155 6.7741 16.8418 6.17504 16.4875C6.17504 16.4875 5.88637 16.7762 5.56219 17.1004C5.32684 17.3361 5.00738 17.4682 4.67445 17.4682C4.34184 17.4682 4.02234 17.3361 3.78703 17.1004C3.50148 16.8148 3.18516 16.4985 2.89957 16.213C2.66395 15.9776 2.5318 15.6582 2.5318 15.3255C2.5318 14.9926 2.66395 14.6732 2.89957 14.4378C3.22375 14.1136 3.51246 13.8249 3.51246 13.8249C3.15816 13.2259 2.88457 12.5735 2.70629 11.8828H1.84117C1.14797 11.8828 0.585938 11.3208 0.585938 10.6276V9.37238C0.585938 8.67922 1.14797 8.11719 1.84117 8.11719H2.70629C2.88457 7.42649 3.15816 6.7741 3.51246 6.17504C3.51246 6.17504 3.22375 5.88637 2.89957 5.56219C2.66395 5.32684 2.5318 5.00742 2.5318 4.67446C2.5318 4.34184 2.66395 4.02238 2.89957 3.78703C3.18516 3.50145 3.50148 3.18516 3.78703 2.89957C4.02234 2.66395 4.34184 2.5318 4.67445 2.5318C5.00738 2.5318 5.32684 2.66395 5.56219 2.89957C5.88637 3.22375 6.17504 3.51246 6.17504 3.51246C6.7741 3.15817 7.42652 2.88453 8.11719 2.70629V1.84113C8.11719 1.14793 8.67918 0.585939 9.37238 0.585939H10.6276C11.3208 0.585939 11.8828 1.14793 11.8828 1.84113V2.70629Z"
            stroke="currentColor"
            strokeWidth={1.3}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10 6.23438C12.0783 6.23438 13.7656 7.92168 13.7656 10C13.7656 12.0783 12.0783 13.7656 10 13.7656C7.92168 13.7656 6.23438 12.0783 6.23438 10C6.23438 7.92168 7.92168 6.23438 10 6.23438Z"
            stroke="currentColor"
            strokeWidth={1.3}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_536_42823">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function Sidebar({ sections, toByKey, currentUser: _currentUser }: SidebarProps) {
  const navRef = useRef<HTMLElement | null>(null);
  const location = useLocation();
  const bottomKeys = ['admin'];
  const icons = {
    products: <ProductsIcon />,
    packages: <PackagesIcon />,
    prints: <LabelPrintsIcon />,
    templates: <TemplatesIcon />,
    admin: (
      <img
        src="/icons/setting.svg"
        alt=""
        className="nav-admin-icon"
        aria-hidden="true"
        width={19.602}
        height={20.281}
        loading="eager"
      />
    ),
  };
  const availableActions = getAvailableActions(_currentUser);
  const visibleSections = sections.filter((section) =>
    !section.requiredActions?.length || section.requiredActions.some((action) => availableActions.includes(action)));
  const topSections = visibleSections.filter((s) => !bottomKeys.includes(s.key));
  const bottomSections = visibleSections.filter((s) => bottomKeys.includes(s.key));

  const isAdminRoute = (pathname: string) => {
    const path = pathname || '';
    return (
      path.startsWith('/admin') ||
      path.startsWith('/brands') ||
      path.startsWith('/organizations') ||
      path.startsWith('/imports') ||
      path.startsWith('/facilities') ||
      path.startsWith('/users')
    );
  };

  useLayoutEffect(() => {
    const nav = navRef.current;
    if (!nav) return;

    let rafId = 0;

    const updateIndicator = () => {
      const active = nav.querySelector('.nav-item.active') as HTMLElement | null;
      if (!active) {
        nav.style.setProperty('--nav-active-opacity', '0');
        return;
      }

      nav.style.setProperty('--nav-active-top', `${active.offsetTop}px`);
      nav.style.setProperty('--nav-active-height', `${active.offsetHeight}px`);
      nav.style.setProperty('--nav-active-opacity', '1');
    };

    rafId = window.requestAnimationFrame(updateIndicator);
    window.addEventListener('resize', updateIndicator);

    return () => {
      window.cancelAnimationFrame(rafId);
      window.removeEventListener('resize', updateIndicator);
    };
  }, [location.pathname, sections]);

  const navLinkButton = (section: SidebarSection) => {
    const adminActive = section.key === 'admin' && isAdminRoute(location.pathname);
    return (
      <NavLink
        key={section.key}
        to={toByKey[section.key] || '/'}
        className={({ isActive }) => {
          const active = isActive || adminActive;
          return `nav-item ${active ? 'active' : ''}`;
        }}
        data-testid={`nav-${section.key}`}
        aria-label={section.label}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '16px',
        }}
      >
        {({ isActive }) => {
          const active = isActive || adminActive;
          const isAdmin = section.key === 'admin';
          return (
          <>
            {icons[section.key] && (
              <span
                className="nav-icon"
                style={{
                  color: active && !isAdmin ? 'var(--panel)' : undefined,
                  backgroundColor: active ? 'var(--nav-icon-background)' : undefined,
                  borderRadius: '5px',
                  padding: '3.5px',
                }}
              >
                {isAdmin ? (
                  <span className={`nav-admin-icon-wrap${active ? ' active' : ''}`}>{icons[section.key]}</span>
                ) : (
                  icons[section.key]
                )}
              </span>
            )}
            <span className={`nav-label${isAdmin ? ' nav-label--admin' : ''}`}>{section.label}</span>
            {!icons[section.key] && (
              <span className="nav-label" aria-hidden>
                {section.label[0]}
              </span>
            )}
          </>
          );
        }}
      </NavLink>
    );
  };

  return (
    <aside className="sidebar collapsed" data-testid="sidebar">
      <nav
        ref={navRef}
        className="sidebar-nav"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <div>
          {topSections.map((section) => navLinkButton(section))}
        </div>

        <div
          aria-hidden="true"
          style={{
            borderTop: '1px solid #e1e4ea',
            marginTop: 8,
            marginBottom: 8,
          }}
        />

        <div style={{ marginTop: 'auto' }}>
          {bottomSections
              .filter((section) => !section.isHidden)
              .map((section) => navLinkButton(section))}
        </div>
      </nav>
    </aside>
  );
}
